import React from 'react';
import { Reveal } from '../ui/Reveal';
import { RESERVA_LINK } from '../../data/retiro';
const PUNTOS = [{
  emoji: '💫',
  titulo: 'Eleva tu Frecuencia',
  texto: 'Alinéate con el poder del amor y vibra en tu versión más auténtica y luminosa.'
}, {
  emoji: '🌸',
  titulo: 'Regálate Transformación',
  texto: 'La paz, el poder y el amor auténtico son tu derecho divino. Es hora de activarlos.'
}, {
  emoji: '🔥',
  titulo: 'Reserva tu Lugar',
  texto: 'Los cupos son limitados. Este viaje está magnetizado para quienes han sentido el llamado de Bali.'
}];
export function Llamado() {
  return <section className="w-full px-5 py-24 sm:px-8 sm:py-32" data-id="element-138">
      <div className="mx-auto max-w-4xl text-center" data-id="element-139">
        <Reveal data-id="element-140">
          <span className="text-xs font-medium uppercase tracking-[0.28em]" style={{
          color: 'var(--satinsheengold)'
        }} data-id="element-141">
            El Llamado a la Acción
          </span>
          <h2 className="mt-4 font-heading text-3xl font-light leading-tight sm:text-5xl" style={{
          color: 'var(--ink)'
        }} data-id="element-142">
            Tu Momento es Ahora — Su Nombre es Amor
          </h2>
          <p className="mt-6 text-base leading-relaxed" style={{
          color: 'rgba(42,36,32,0.72)'
        }} data-id="element-143">
            Bali te espera para que dejes de esconder tu sabiduría y comiences a
            reconocer tus poderes. Este retiro es un lujo silencioso — es el
            legado más poderoso que puedes darte a ti misma y a las generaciones
            que vienen.
          </p>
        </Reveal>

        <div className="mt-14 grid gap-6 sm:grid-cols-3" data-id="element-144">
          {PUNTOS.map((p, i) => <Reveal key={p.titulo} delay={i * 0.1} data-id="element-145">
              <div className="flex h-full flex-col items-center gap-3 px-2" data-id="element-146">
                <span className="text-4xl" data-id="element-147">{p.emoji}</span>
                <h3 className="font-heading text-lg font-normal" style={{
              color: 'var(--ink)'
            }} data-id="element-148">
                  {p.titulo}
                </h3>
                <p className="text-sm leading-relaxed" style={{
              color: 'rgba(42,36,32,0.68)'
            }} data-id="element-149">
                  {p.texto}
                </p>
              </div>
            </Reveal>)}
        </div>

        <Reveal delay={0.2} data-id="element-150">
          <a href={RESERVA_LINK} className="mt-12 inline-flex rounded-full px-10 py-4 text-sm font-medium text-white transition-transform hover:scale-[1.04]" style={{
          backgroundColor: 'var(--darkgoldenrod)'
        }} data-id="element-151">
            Quiero reservar mi lugar
          </a>
        </Reveal>
      </div>
    </section>;
}